import gCard from "@/components/g-card/g-card.vue"
import gButton from "@/components/g-button/g-button.vue"
import gForm from "@/components/g-form/g-form.vue";
import CartaPropostaController from "@/shared/controllers/cartaProposta/CartaPropostaController";
import { defineComponent } from "vue";
import Tools from "@/shared/services/tools";



const name = 'DetalheCartaProposta'
export default defineComponent({
  name,

  components: {
    'g-card':gCard,
    'g-button': gButton,
    'g-form': gForm
  },

  props: { },

  mounted () {
    var CartaPropId = this.$route.params.id
    this.CartaPropostaId = CartaPropId
    this.informacoescartaproposta()
  },

  updated () { },

  data () {
    return {
      options: [],
      infos: {},
      CartaPropostaId: null,
      InformacoesCartaPropostaSelecionado: {},
      MascaraCnpj: {},
      orcamentosCartaProposta: [],
      ObservacoesNegociacaoOriginalTextoCortado: []
    }
  },

  methods: {
    formataDecimal(valor){
      return Tools.valorDecimalFormatado(valor)
    },

    formataMonetario(valor){ 
      return Tools.valorMonetario4Digitos(valor)
    },

    informacoescartaproposta(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetCartasPropostasDetalhe/${this.CartaPropostaId}`,
        data:
        {}
      })
        .then((response) => {
          this.$isLoading(false)
          this.InformacoesCartaPropostaSelecionado = response.data.data
          this.orcamentosCartaProposta = response.data.data.orcamentosDetalhes          
          this.MascaraCnpj = Tools.formatarCnpj(response.data.data.cnpj)
          this.ObservacoesNegociacaoOriginal = response.data.data.observacaoNegociacao.split("## SO ##") //recortando o texto separando por cada ##so##
          
          this.ObservacoesNegociacaoOriginal.shift() //apagando primeiro elemento que sempre gera vazio
          this.ObservacoesNegociacaoOriginal.forEach((obs)=>{ //adicionando ##so## novamente em cada inicio de elemento agora separado para o v-for
            obs = '## SO ## ' + obs
            this.ObservacoesNegociacaoOriginalTextoCortado.push(obs)
        })          
            this.$isLoading(false)
          })
          .catch(() => {
            this.$isLoading(false)
          });
    },

    voltar (){
      this.$router.push(`/consultar-cartas-proposta`);
    },
    getMarkupInformacoes(orcamento){
      this.$isLoading(false)
      if(orcamento.infos){
        orcamento.infos = undefined
        return;
      }
      let orcamentoId = orcamento.orcamentoId
      CartaPropostaController.GetMarkupInformacoesByOrcamentoId(orcamentoId,this.CartaPropostaId ).requisicao
      .then(res => {
        this.infos = res.data.data
        orcamento.infos = this.infos;
        this.$isLoading(false)
      })
    },


    enviaDetalhesOrcamento(orcamento){
      let orcamentoId = orcamento.orcamentoId
      this.$router.push(`/orcamento-informacao/${orcamentoId}`)
    },

    TelaDetalhes(){
      this.$router.push(`/gerar-carta-proposta-finalizado/${this.CartaPropostaId}`)

    }

  },

  computed: {
    existeAgrupador(){
      if(this.InformacoesCartaPropostaSelecionado.clienteAgrupadores){
        return this.InformacoesCartaPropostaSelecionado.clienteAgrupadores.length === 0
      }
      return false;
    }
  },

});